import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MissingTranslationHandler, TranslateModule } from '@ngx-translate/core';
import { LoggerModule } from 'ngx-logger';
import { ConnectedMissingTranslationHandler } from './connected-missing-translation-handler';
import { AsPipe } from './pipes/as.pipe';
import { CastPipe } from './pipes/cast.pipe';
import { ContainsPropertyPipe } from './pipes/contains-property.pipe';
import { FormControlPipe } from './pipes/form-control.pipe';
import { HeadPipe } from './pipes/head.pipe';
import { TypeofPipe } from './pipes/typeof.pipe';
import { InstanceofPipe } from './pipes/instanceof.pipe';
import { BooleanPipe } from './pipes/boolean.pipe';
import { AsStringPipe } from './pipes/as-string.pipe';

const components = [
  AsPipe,
  AsStringPipe,
  CastPipe,
  HeadPipe,
  FormControlPipe,
  TypeofPipe,
  InstanceofPipe,
  ContainsPropertyPipe,
  BooleanPipe,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    TranslateModule.forChild({
      useDefaultLang: false,
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: ConnectedMissingTranslationHandler },
      isolate: false,
      extend: true,
    }),
    LoggerModule.forChild(),
  ],
  exports: components,
})
export class AngularSharedUtilsCoreModule {}
